<script lang="ts" setup>
import SectionReferences from "~/components/section/SectionReferences.vue";

const {collectionUri, pageUri} = useI18nCollection();
const {getAllButIndex} = usePage();
const hero = await queryCollection(collectionUri('pro')).path(pageUri('pro/hero')).first();
const pages = await queryCollection(collectionUri('pro')).all();
const { t } = useI18n();

// SEO optimization
useSeo({
  title: hero?.seoTitle || t('seo.pro.title'),
  description: hero?.seoDescription || t('seo.pro.description'),
});
</script>

<template>
  <main>
    <SectionPageHeader :page="hero" class="mb-8"/>
    <div class="page-container">
      <ArticleLayout
              :page="pages.find(p => p.path.includes('intro-about-aermec'))!"
              class="mb-8"
              content-class="tablet:max-w-1/2 mx-auto"
              img-aspect-ratio="aspect-16/9"
              picture-class="max-w-2xl mx-auto block"
      />
    </div>

    <section
            class="page-container flex flex-wrap tablet:max-w-[65vw] justify-center mb-8">
      <ArticleHighlight
              v-for="service in getAllButIndex(pages.filter(p => p.path.includes('services/')))"
              :key="service.path"
              :icon-ref="service?.meta?.icon || ''"
              :title="service.title"
              class="basis-1/2 tablet:basis-1/3 text-center mb-6 tablet:mb-12"
              title-class="text-brand text-nowrap"
      >
        <template #summary>
          <ContentRenderer :value="service" class="tablet:text-sm laptop:text-base"/>
        </template>
        <template #subtitle>
          <small class="block -mt-2 text-muted text-grey text-sm">{{ service.meta.subtitle }}</small>
        </template>
      </ArticleHighlight>
    </section>

    <ArticleOddEven
            :page="pages.find(p => p.path.includes('/about'))"
            class="page-container-md mb-12"
            picture-class="basis-4/9 shrink-0"
            title-class="section-title text-tertiary mb-4"
    />

    <div class="p-2">
      <div class="bg-brand-light py-8 rounded-img">
        <SectionAccordion :pages="pages.filter(p => p.path.includes('accordion'))"/>
      </div>
    </div>

    <div class="p-2 mb-12">
      <div class="bg-brand-light py-8 rounded-img">
        <SectionIncentives :pages="pages.filter(p => p.path.includes('incentive'))"/>
      </div>
    </div>

    <SectionReferences :page="pages.find(p => p.path.includes('/references'))" class="page-container mb-12"/>

  </main>
</template>

<style scoped>

</style>